export const monCompteMaFideliteProps = () => ({
  fidelite: {
    type: Array,
    required: false,
    default: () => []
  },
  cardSelectedLibelle: {
    type: String,
    required: false,
    default: null
  },
  cardSelected: {
    type: Object,
    required: false,
    default: () => { }
  },
  errorDefis: {
    type: Boolean,
    required: false,
    default: false
  },
  isRegisteredCard: {
    type: Boolean,
    required: false,
  }
})

export const monCompteMaFideliteEmits = () => ([
  "setPopinAjoutCarte",
  "redirectCreationCarte"
])

export const useMonCompteMaFidelite = (props, context) => {
  const cardSelectedLibelleData = ref(props.cardSelectedLibelle)

  const addNewCard = () => {
    if (props.cardSelectedLibelle === "malin") {
      context.emit("setPopinAjoutCarte")
    } else {
      context.emit("redirectCreationCarte")
    }
  }

  const filterFid = computed(() => {
    const value = props.fidelite.filter(
      (carte) => carte.attributes.type_carte !== "carrefour"
    );

    return value
  })

  return { cardSelectedLibelleData, addNewCard, filterFid }

}